// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__rYmgs","info":"PatientInfo_info__1KAex"};